import { helper } from '@ember/component/helper';

import { camelize } from '@ember/string';

import strings from 'rise-ui/config/strings.js';

export default helper(function stringHelper([ key ]) {
  return strings[key] ?? strings[camelize(key)];
});
